import React from "react";
import AppRow from "src/commun/composants/grille/AppRow";
import AppCol from "src/commun/composants/grille/AppCol";
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from "src/routes/AppRoutes";
import { useAppText } from "src/commun/composants/AppText";

const Finalisation = () => {
  const { tString } = useAppText();
  const navigate = useNavigate();

  return (
    <AppRow>
      <AppCol>
        <label>{tString("migration.step.4.intro")}</label>
      </AppCol>
      <AppCol>
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={() => navigate(AppRoutes.ACCUEIL_PATH.getPath())}
          value={tString("action.redirect.page.accueil")}
        />
      </AppCol>
    </AppRow>
  );

};

export default Finalisation;